<template>
  <ul class="creature-traits">
    <li class="creature-trait" v-if="traits.includes('multiattack')">
      ➤ <strong>Multiattack ({{multiattack}}):</strong>
      The monster makes {{multiattack}} attacks against its enemies, dealing {{Math.floor(damage / multiattack)}} damage per attack.
    </li>
    <li class="creature-trait" v-for="trait in processedTraits" :key="trait.id" v-if="trait.id != 'multiattack'">
      ➤ <strong>{{trait['title']}}:</strong>
      {{trait['description']}}
    </li>
  </ul>
</template>

<script>
import traitData from '../data/traits.json';
import powerData from '../data/powers.json';

const data = Object.assign({}, traitData, powerData);

export default {
  props: ['traits', 'damage', 'type'],
  computed: {
    multiattack() {
      if(this.archtype == 'minion' || this.damage < 9) return 1;
      if(this.damage < 30) return 2;
      if(this.damage < 60) return 3;
      return 4;
    },
    processedTraits() {
      let traits = this.traits;
      if(this.type == 'elite') {
        traits = ['elite-action', ...traits];
      } else if(this.type == 'solo') {
        traits = ['solo-actions', 'phase-transition', ...traits];
      }

      return traits.map(trait => Object.assign({
          id: trait
        }, data[trait] !== undefined ? data[trait] : data['broken-trait']));
    }
  }
}
</script>

<style lang="scss">
  .creature-block .creature-traits {
    list-style: none;
    margin: 0;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/trait-list.vue